<div class="main">
  <router-outlet />
  <app-spinner></app-spinner>
</div>
